import Api from 'app/helpers/api'
import {AbilityFillingStepEnum} from "app/components/shared/enums/global-enums.tsx"
import {produce} from 'immer'

export const courseElmComponentsSlice = ((set, get) => ({
  courseElmComponents: [],

  skillImageData: null,
  attitudeImageData: null,

  currentKnlgElmId: null,
  currentKnlgElmType: AbilityFillingStepEnum.STEP_1,

  actions: {
    fetchCourseElmComponents: async (params) => {
      const api = new Api();
      params.course_id = params.courseId;
      api.getCourseElmComponents(params)
        .then((response) => {
          set((state) => ({ courseElmComponents: response.data.course_elm_components }));
        })
      .catch((err) => console.log(err));
    },

    toggleComponents: (elmTick) => {
      let newSkillState = !get().skillComponents;
      let newAttitudeState = !get().attitudeComponents;

      if (elmTick.id !== get().currentKnlgElmId){
        newSkillState= true;
        newAttitudeState= true;
      }

      const cStep = get().fillingAbilitiesStep; 
      if (cStep === AbilityFillingStepEnum.STEP_1){
        set((state) => ({ currentKnlgElmType: cStep, currentKnlgElmId: elmTick.id, skillComponents: newSkillState}));
      }else if (cStep === AbilityFillingStepEnum.STEP_2){
        set((state) => ({ currentKnlgElmType: cStep, currentKnlgElmId: elmTick.id, attitudeComponents: newAttitudeState}));
      } 
    },

    toggleKnlgToElm: (knowledgeComponent)=> {
      const cStep = get().fillingAbilitiesStep; 
      let courseElmComponents;

      courseElmComponents = [...get().courseElmComponents];

      const currentKnlgElmId = get().currentKnlgElmId;

      const found = courseElmComponents.find(knlgElm => {
         return (knlgElm.knowledge_component_id === knowledgeComponent.id && 
                knlgElm.elm_type === cStep &&
                knlgElm.elm_id === currentKnlgElmId);
      });


      if (found){
        courseElmComponents = courseElmComponents.filter(knlgElm => {
                 return (knlgElm.knowledge_component_id !== knowledgeComponent.id || 
                        knlgElm.elm_type !== cStep ||
                        knlgElm.elm_id !== currentKnlgElmId);
              }); 
      }else{
        courseElmComponents.push({course_id: knowledgeComponent.course_id,
          elm_id: currentKnlgElmId, 
          elm_type: cStep, 
          knowledge_component_id: knowledgeComponent.id});
      }


      set(produce((state) => { 
          state.courseElmComponents = courseElmComponents;
      }));

      // set((state) => ({courseElmComponents: courseElmComponents}));

      // get().actions.refreshUncompleteElms(elm);
      get().actions.setUnsavedChanges(true);
    },

    updateKnlgElms: async () => {
      const api = new Api();
      const params = {};
      params.courseId = get().course.id;
      params["course_elm_components"] = get().courseElmComponents;

      let success = false;

      await api.updateCourseElmComponents(params).then((response) => {
          success = true;
        }
      )
      .catch((err) => {
        console.log(err)
      });
      
      return success;
    },




  }

}))